import { styled } from 'styled-components'

import { TextArea, TextAreaProps } from '../../TextArea'

export const TextAreaEdit = styled(TextArea)<TextAreaProps>`
  padding: 0 4px;
`
